import React from 'react';
import { reportError } from '../utils/errorMonitor';

/**
 * Lapie bledy renderowania React i raportuje je do /api/monitoring/client-error.
 * Pokazuje fallback UI uzytkownikowi.
 */
export class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, errorId: null, message: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, message: error?.message || 'Nieoczekiwany blad' };
    }

    componentDidCatch(error, info) {
        try {
            reportError({
                message: error?.message || 'React render error',
                stack: (error?.stack || '') + '\n\nComponentStack:\n' + (info?.componentStack || ''),
                extra: { type: 'react_boundary' },
            });
        } catch (_) { /* nic */ }
    }

    handleReload = () => {
        this.setState({ hasError: false, message: null });
        if (typeof window !== 'undefined') window.location.reload();
    };

    render() {
        if (this.state.hasError) {
            return (
                <div style={{
                    minHeight: '100vh',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '24px',
                    background: '#f8fafc',
                    fontFamily: 'system-ui, sans-serif',
                }}>
                    <div style={{
                        maxWidth: '560px',
                        background: 'white',
                        borderRadius: '12px',
                        boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
                        padding: '32px',
                        textAlign: 'center',
                    }}>
                        <div style={{ fontSize: '48px', marginBottom: '12px' }}>⚠️</div>
                        <h1 style={{ fontSize: '20px', fontWeight: 700, marginBottom: '8px', color: '#0f172a' }}>
                            Cos poszlo nie tak
                        </h1>
                        <p style={{ color: '#64748b', marginBottom: '20px', fontSize: '14px' }}>
                            Wystapil nieoczekiwany blad. Zostal automatycznie zgloszony zespolowi.
                        </p>
                        {this.state.message && (
                            <pre style={{
                                background: '#f1f5f9',
                                color: '#334155',
                                padding: '12px',
                                borderRadius: '8px',
                                fontSize: '12px',
                                textAlign: 'left',
                                overflow: 'auto',
                                marginBottom: '20px',
                                maxHeight: '120px',
                            }}>{this.state.message}</pre>
                        )}
                        <button
                            onClick={this.handleReload}
                            style={{
                                background: '#2563eb',
                                color: 'white',
                                border: 'none',
                                padding: '10px 20px',
                                borderRadius: '8px',
                                fontSize: '14px',
                                fontWeight: 600,
                                cursor: 'pointer',
                            }}
                        >
                            Przeladuj strone
                        </button>
                    </div>
                </div>
            );
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
